import DOMPurify from 'dompurify';

const TAGS_PERMITIDOS = ['b', 'strong', 'i', 'em', 'u', 'ul', 'ol', 'li', 'a', 'p', 'br'];
const ATRIBUTOS_PERMITIDOS = ['href', 'target', 'rel'];

export function sanitizar(html) {
  if (!html) return '';
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: TAGS_PERMITIDOS,
    ALLOWED_ATTR: ATRIBUTOS_PERMITIDOS,
  });
}

export function htmlEstaVacio(html) {
  if (!html) return true;
  const soloTexto = html.replace(/<[^>]+>/g, '').replace(/&nbsp;/g, ' ').trim();
  return soloTexto.length === 0;
}
